import {merge} from '#core/utils/config-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generatePivotsRow} from '#core/application/modules/tiles/pivot/index.js';
import {generateToggleButton} from '#core/application/modules/tiles/button/index.js';
import {generateSkeletonPart} from '#core/application/modules/tiles/skeleton-part/index.js';
import {generateSecondaryLink} from '#core/application/modules/tiles/link/index.js';
import {generateViewSwitcher} from '#core/application/modules/tiles/view-switcher/index.js';
import {generateScoreboard} from '#core/application/modules/tiles/scoreboard/index.js';

export function eventPageFactory(PALETTE) {
    const EVENT_PAGE_VISUALISATION_VIEW_SWITCHER = generateViewSwitcher(PALETTE.EVENT_PAGE_VISUALISATION_VIEW_SWITCHER);
    const MARKETS_SUBCATEGORIES_SWITCHER = generateViewSwitcher(PALETTE.MARKETS_SUBCATEGORIES_SWITCHER);

    return {
        EventPage: {
            visualisationContainer: {
                style: {
                    ...resolveBackground(PALETTE.EVENT_PAGE_VISUALISATION_CONTAINER_BG),
                    _mobile_boxShadow: PALETTE.EVENT_PAGE_VISUALISATION_CONTAINER_SHADOW,
                },
            },
            visualisationSkeletonLoader: {
                style: {
                    container: {
                        flexDirection: 'column',
                    },
                },
            },
            pageHeaderConfig: {
                labelContainer: {
                    style: {
                        flex: 'initial',
                    },
                },
            },
            infoCardWrapper: {
                style: {
                    ...resolveBackground(PALETTE.EVENT_PAGE_FINISHED_EVENT_CONTAINER_BG),
                },
            },
            text: {
                style: {
                    ...PALETTE.EVENT_PAGE_FINISHED_EVENT_TEXT,
                },
            },
            button: generateSecondaryLink(PALETTE.EVENT_PAGE_FINISHED_EVENT_LINK),
            eventCardsCarousel: {
                headerText: {
                    style: {
                        ...PALETTE.EVENT_PAGE_FINISHED_EVENTS_TITLE_TEXT,
                    },
                },
            },
        },
        // because this component doesn't have nested config
        EventVisualisationController: {
            container: {
                itemSpacing: 4,
            },
            toggleMenuContainer: EVENT_PAGE_VISUALISATION_VIEW_SWITCHER.switcherContainer,
            toggleButton: EVENT_PAGE_VISUALISATION_VIEW_SWITCHER.switcherButton,
        },
        EventVisualisationSkeleton: {
            container: {
                style: {
                    ...resolveBackground(PALETTE.EVENT_PAGE_VISUALISATION_CONTAINER_BG),
                },
            },
            marketGroupCategoriesMenuContainer: {
                style: {
                    padding: 8,
                },
            },
            marketGroupCategoriesMenuItem: generateSkeletonPart(PALETTE.EVENT_PAGE_VISUALISATION_SKELETON_PART),
            scoreboardSkeletonPart: generateSkeletonPart(PALETTE.EVENT_PAGE_VISUALISATION_SKELETON_PART),
        },
        // Scoreboards
        Scoreboard: merge(generateScoreboard(PALETTE.SCOREBOARD), {
            scoreboard: {
                sports: {
                    setBased: ['tennis', 'volleyball', 'beach_volleyball', 'badminton', 'table_tennis', 'padel'],
                },
            },
            container: {
                style: {
                    borderRadius: '8px',
                },
            },
            backgroundImages: {
                football: 'card-background/scoreboard_bg_football.png',
                winter_sports: 'card-background/scoreboard_bg_wintersports.png',
                motorcycling: 'card-background/scoreboard_bg_motorcycling.png',
                motorsport: 'card-background/scoreboard_bg_motor_sports.png',
                formula1: 'card-background/scoreboard_bg_motor_sports.png',
            },
            content: {
                style: {
                    padding: 8,
                    ...resolveBackground(PALETTE.SCOREBOARD_CONTAINER_BG),
                    _desktop_boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
                    borderRadius: 8,
                    textAlign: 'center',
                },
            },
        }),
        // Event markets switcher
        EventMarketsGroupSwitcher: {
            categoryContainer: {
                style: {
                    ...resolveBackground(PALETTE.MARKETS_CATEGORIES_CONTAINER_BG),
                },
            },
            categorySelector: merge(generatePivotsRow(PALETTE.MARKETS_CATEGORIES_SELECTOR), {
                buttonScrollPane: {
                    contentContainer: {
                        style: {
                            _mobile_padding: 0,
                        },
                    },
                },
            }),
            subCategorySelector: {
                buttonScrollPane: {
                    contentContainer: merge(MARKETS_SUBCATEGORIES_SWITCHER.switcherContainer, {
                        style: {
                            height: 40,
                            padding: 2,
                        },
                    }),
                },
                item: MARKETS_SUBCATEGORIES_SWITCHER.switcherButton,
            },
            groupSelector: {
                marketsMenu: {
                    item: generateToggleButton(PALETTE.MARKETS_GROUPS_SELECTOR_BUTTON, true),
                },
                buttonBar: {
                    container: {
                        style: {
                            padding: 0,
                        },
                    },
                    button: generateToggleButton(PALETTE.MARKETS_GROUPS_SELECTOR_BUTTON, true),
                    style: {
                        newFeature: {
                            ...resolveBackground(PALETTE.MARKETS_GROUPS_SELECTOR_BUTTON_NEW_FEATURE_LABEL_BG),
                            borderRadius: PALETTE.MARKETS_GROUPS_SELECTOR_BUTTON_NEW_FEATURE_LABEL_BORDER_RADIUS,
                            lineHeight: '16px',
                            bottom: '-7px',
                            right: '-4px',
                            ...PALETTE.MARKETS_GROUPS_SELECTOR_BUTTON_NEW_FEATURE_LABEL_TEXT,
                        },
                    },
                    expandButtonText: {
                        style: {
                            ...PALETTE.MARKETS_GROUPS_MORE_BUTTON_TEXT,
                        },
                    },
                    expandButtonIcon: {
                        image: {
                            style: {
                                fill: PALETTE.MARKETS_GROUPS_MORE_BUTTON_ICON_COLOR,
                            },
                        },
                    },
                },
            },
        },
        MarketGroupSelectorSkeleton: {
            container: {
                style: {
                    _mobile_padding: '8px 8px 0 8px',
                },
            },
        },
    };
}
